import React from 'react';

export default function SkillGroup({ title, items }) {
  return (
    <div className="skill-group">
      <h3>{title}</h3>
      <div className="skill-tags">
        {items.map((item) => (
          <span key={item} className="skill-tag">{item}</span>
        ))}
      </div>
    </div>
  );
}
